import { useState } from 'react';
import ConfigurationTitle from './ConfigurationPanelTitle';
import useStyles from './styles';
import { ConfigurationType } from './types';

interface ConfigurationPanelProps {
  type: ConfigurationType;
  children: JSX.Element[];
}

export const ConfigurationPanel = ({ children, type }: ConfigurationPanelProps): JSX.Element => {
  const styles = useStyles();
  const [open, setOpen] = useState(true);

  const handleClickCollpase = () => {
    setOpen(!open);
  };

  return (
    <div className={styles.panel}>
      <ConfigurationTitle type={type} open={open} onClickCollapse={handleClickCollpase} />
      {open && children}
    </div>
  );
};

export default ConfigurationPanel;
